import React from 'react';
import { Link } from 'react-router-dom';
import { Package, FileDown, ClipboardCheck, PlayCircle } from 'lucide-react';

const KIT = '/downloads/kojiru-claim-records-reference-kit-draft-0.4.zip';
const SCOPE = '/downloads/kojiru-claim-records-pilot-scope-sheet.pdf';
const INSIDE = [
  'A sample claims file for /.well-known/claim-records.json',
  'A small case-status endpoint in Python (FastAPI): delivery receipts, safe retries, stable status, one contest per decision',
  'Tests that check claim IDs, spoken codes, and event hashes against the published test vectors',
];

export function ReferenceKit() {
  const btn = 'inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors';
  return (
    <section className="rounded-2xl border border-amber-500/30 bg-amber-500/[0.04] p-6" data-testid="claims-reference-kit">
      <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2"><Package className="w-4 h-4 text-amber-300" /> Reference kit for builders</h2>
      <p className="text-sm text-gray-300 leading-relaxed max-w-3xl">A runnable starting point for the merchant side of a 30-day cancellation pilot, based on Draft 0.4.</p>
      <ul className="mt-3 space-y-1.5 text-sm text-gray-400 list-disc pl-5" data-testid="claims-reference-kit-contents">
        {INSIDE.map((t) => <li key={t}>{t}</li>)}
      </ul>
      <p className="mt-3 text-xs text-gray-500 max-w-3xl" data-testid="claims-reference-kit-notice">Sample code under the Apache License 2.0. You run it on your own systems. Kojiru does not host, run, or support it as a service and receives no data from it. Replace the signature check, key, and storage before any real use.</p>
      <div className="flex flex-wrap gap-3 mt-5">
        <a href={KIT} download className={`${btn} bg-amber-300 text-black hover:bg-amber-200`} data-testid="claims-download-reference-kit"><FileDown className="w-4 h-4" /> Download the kit (ZIP)</a>
        <Link to="/specs/claim-records/demo" className={`${btn} border border-amber-500/40 text-amber-200 hover:border-amber-400`} data-testid="claims-open-demo"><PlayCircle className="w-4 h-4" /> Try it in your browser</Link>
        <a href={SCOPE} target="_blank" rel="noopener noreferrer" className={`${btn} border border-white/15 text-white hover:border-white/40`} data-testid="claims-download-scope-sheet"><ClipboardCheck className="w-4 h-4" /> Pilot scope sheet (PDF, 1 page)</a>
      </div>
    </section>
  );
}
